import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import style from "../product/HorizontalCard.module.scss";
import SquareWrapper from "layouts/wrapper/SquareWrapper";
import SkeletonImage from "components/skeleton/SkeletonImage";
import clsx from "classnames";
import VerticalFlex from "layouts/flex/VerticalFlex";
import PaddingWrapper from "layouts/wrapper/PaddingWrapper";
import Center from "layouts/wrapper/Center";
import SkeletonText from "components/skeleton/SkeletonText";
import Inline from "layouts/container/Inline";
import P from "components/P";
import { addCommas } from "shared/utils/Utils";
import CustomIcon from "components/icons/CustomIcon";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "providers/AuthProvider";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import cartImg from "resources/img/category/cartIcon.png";
import Dummy from "components/Dummy";
import EventSticker from "../product/sticker/EventSticker";

function NewWishCard(props) {
    const { data, skeleton, onProductClick, addCartButtonClick , deleteButtonClick } = props;
    const { userName } = useContext(AuthContext);
    const { isMobile } = useContext(BrowserDetectContext);
    const [isMounted, setMounted] = useState(false);
    const [isData, setData] = useState();

    useEffect(() => {
        if (data) {
            setMounted(true);
        }
    }, [data])
    useEffect(() => {
        if (isMounted) {
            setData(data);
        }
    }, [isMounted])


    return (
        <FlexChild>
            {
                isMobile
                    ?
                    <div onClick={onProductClick}>
                        <VerticalFlex gap={10}>
                            <FlexChild>
                                <HorizontalFlex gap={10} padding={"10px"}>
                                    <FlexChild width={"fit-content"}>
                                        {
                                            skeleton
                                                ?
                                                <div className={style.thumbnail} style={{ backgroundColor: "#ebebeb" }}>
                                                    <SquareWrapper>
                                                        {
                                                            skeleton ? <SkeletonImage width={100} />
                                                                : <img className={clsx(style.image, style.horizontalMobile)} src={data && data.thumbnail} alt={""} />
                                                        }
                                                    </SquareWrapper>
                                                </div>
                                                :
                                                <div className={style.horizontalThumbnail}>
                                                    {
                                                        props.rank &&
                                                        <div className={style.indexCircle}>{props.rank}</div>
                                                    }
                                                    <img className={clsx(style.image, style.horizontalMobile)} src={data && data.thumbnail} alt={""} />
                                                </div>
                                        }
                                    </FlexChild >
                                    <FlexChild backgroundColor={"white"} width={"40%"}>
                                        <VerticalFlex flexStart>
                                            <FlexChild >
                                                <PaddingWrapper padding={"15px 0 0 0"}>
                                                    {
                                                        skeleton ?
                                                            <Center width={"100%"} textAlign={"left"}>
                                                                <SkeletonText width={50} size={16} />
                                                                <SkeletonText width={50} size={16} />
                                                                <SkeletonText width={50} size={16} />
                                                                <Inline>
                                                                    <SkeletonText width={50} size={10} />
                                                                    <SkeletonText width={50} size={10} />
                                                                    <SkeletonText width={50} size={10} />
                                                                </Inline>
                                                                <SkeletonText width={50} size={10} />
                                                                <SkeletonText width={50} size={10} />
                                                            </Center>
                                                            :
                                                            <P cursor textHover ellipsis size={14} weight={"700"} whiteSpace={'nowrap'} overFlow={'hidden'} textOverflow={'ellipsis'}>{data && data?.title}</P>
                                                    }
                                                </PaddingWrapper>
                                            </FlexChild>
                                            {
                                                data &&
                                                    data.variants?.length > 0 &&
                                                    data.discount_price ?
                                                    (
                                                        <FlexChild justifyContent={"flex-start"}>
                                                            <P
                                                                textHover
                                                                cursor
                                                                onClick={onProductClick}
                                                                textAlign={"left"}
                                                                size={isMobile ? 16 : 20}
                                                                weight={"bold"}
                                                                color={"rgba(89, 87, 87, 1)"}
                                                                textDecoration={data.currentPrice && "line-through"}
                                                            >
                                                                &#8361;
                                                                {
                                                                    userName
                                                                        ?
                                                                        addCommas(data ? data.discount_price : 0)
                                                                        :
                                                                        "회원공개"
                                                                }

                                                            </P>
                                                        </FlexChild>
                                                    )
                                                    :
                                                    (
                                                        <FlexChild justifyContent={"flex-start"}>
                                                            <P
                                                                textHover
                                                                cursor
                                                                onClick={onProductClick}
                                                                textAlign={"left"}
                                                                size={isMobile ? 16 : 20}
                                                                weight={"bold"}
                                                                color={"rgba(89, 87, 87, 1)"}

                                                            >
                                                                &#8361;
                                                                {
                                                                    userName
                                                                        ?
                                                                        addCommas(data ? data.price : 0)
                                                                        :
                                                                        "회원공개"
                                                                }
                                                            </P>
                                                        </FlexChild>
                                                    )

                                            }
                                            <FlexChild>
                                                {/* <Inline>
                                        {
                                            data.variants && data.variants.map((row, index) => (
                                                <P size={16}>{row.title}{" "}{data.variants.length === index + 1 ? null : " | "}</P>
                                            ))
                                        }
                                    </Inline> */}
                                                <Center width={"100%"}>

                                                    {data && data.event || data && data.discount_price ? (
                                                        <EventSticker isEvent={data.event} discount={data.discount_price} price={data.price} />
                                                    ) : (
                                                        <P
                                                            height={"20px"}
                                                            ellipsis
                                                            size={9}
                                                            weight={"900"}
                                                            color={"red"}
                                                        ></P>
                                                    )}
                                                </Center>
                                            </FlexChild>

                                        </VerticalFlex>
                                    </FlexChild>
                                    <FlexChild width={"fit-content"}>
                                        <HorizontalFlex padding={"0 10px"} justifyContent={"flex-end"}>
                                            <FlexChild width={"max-content"}>
                                                <div onClick={addCartButtonClick} className={style.mobileCartBtn}>
                                                    {/* <CustomIcon name={"shoppingBag"} width={18} color={"#282828"} /> */}
                                                    <img src={cartImg} />
                                                </div>
                                            </FlexChild>
                                        </HorizontalFlex>
                                    </FlexChild>

                                </HorizontalFlex >
                            </FlexChild>
                            <FlexChild>
                                <div style={{ width: "100%", height: "1px", backgroundColor: "#aaa", opacity: 0.5 }} />
                            </FlexChild>
                        </VerticalFlex>



                    </div>

                    :
                    <HorizontalFlex gap={40}>
                        <FlexChild width={"max-content"}>
                            {
                                skeleton
                                    ?
                                    <div className={style.thumbnail} style={{ backgroundColor: "#ebebeb" }}>
                                        <SquareWrapper>
                                            {
                                                skeleton ? <SkeletonImage width={100} />
                                                    : <img className={clsx(style.image, style.horizontal)} src={data.thumbnail} alt={""} />
                                            }
                                        </SquareWrapper>
                                    </div>
                                    :
                                    <div className={style.horizontalThumbnail}>
                                        {
                                            props.rank &&
                                            <div className={style.indexCircle}>{props.rank}</div>
                                        }
                                        <img onClick={onProductClick} className={clsx(style.image, style.horizontal)} src={data && data.thumbnail} alt={""} />

                                    </div>
                            }
                        </FlexChild >
                        <FlexChild backgroundColor={"white"} width={"30%"}>
                            <VerticalFlex>
                                <FlexChild>
                                    <PaddingWrapper padding={"15px 0 0 0"}>
                                        {
                                            skeleton ?
                                                <Center width={"100%"} textAlign={"left"}>
                                                    <SkeletonText width={50} size={16} />
                                                    <SkeletonText width={50} size={16} />
                                                    <SkeletonText width={50} size={16} />
                                                    <Inline>
                                                        <SkeletonText width={50} size={10} />
                                                        <SkeletonText width={50} size={10} />
                                                        <SkeletonText width={50} size={10} />
                                                    </Inline>
                                                    <SkeletonText width={50} size={10} />
                                                    <SkeletonText width={50} size={10} />
                                                </Center>
                                                :
                                                <P textHover cursor onClick={onProductClick} ellipsis size={20} weight={"700"} whiteSpace={'nowrap'} overFlow={'hidden'} textOverflow={'ellipsis'}>{data && data.title}</P>
                                        }
                                    </PaddingWrapper>
                                </FlexChild>
                                <FlexChild alignItems={"flex-start"}>
                                    <Inline>
                                        {
                                            data && data.variants && data.variants.map((row, index) => (
                                                <P size={16}>{row.title}{" "}{data.variants.length === index + 1 ? null : " | "}</P>
                                            ))
                                        }
                                    </Inline>
                                    <Center width={"100%"} maxWidth={200} textAlign={"left"}>

                                        {
                                            isData ?
                                                data.event || data.discount_price ? (
                                                    <EventSticker isEvent={data && data.event} discount={data && data.discount_price} price={data && data.price} />
                                                ) : (
                                                    <P
                                                        height={"20px"}
                                                        ellipsis
                                                        size={12}
                                                        weight={"900"}
                                                        color={"red"}
                                                    ></P>
                                                )
                                                :
                                                null
                                        }
                                    </Center>
                                </FlexChild>
                            </VerticalFlex>
                        </FlexChild>
                        <FlexChild>
                            <HorizontalFlex padding={"0 10px"}>
                                {
                                    data &&
                                        data.variants?.length > 0 &&
                                        data.discount_price ?
                                        (
                                            <FlexChild justifyContent={"flex-end"}>
                                                <P
                                                    textHover
                                                    cursor
                                                    onClick={onProductClick}
                                                    textAlign={"left"}
                                                    size={isMobile ? 16 : 20}
                                                    weight={"bold"}
                                                    color={"rgba(89, 87, 87, 1)"}
                                                    textDecoration={data && data.currentPrice && "line-through"}
                                                >
                                                    &#8361;
                                                    {
                                                        userName
                                                            ?
                                                            addCommas(data && data.discount_price)
                                                            :
                                                            "회원공개"
                                                    }

                                                </P>
                                            </FlexChild>
                                        )
                                        :
                                        (
                                            <FlexChild justifyContent={"flex-end"}>
                                                <P
                                                    textHover
                                                    cursor
                                                    onClick={onProductClick}
                                                    textAlign={"left"}
                                                    size={isMobile ? 16 : 20}
                                                    weight={"bold"}
                                                    color={"rgba(89, 87, 87, 1)"}

                                                >
                                                    &#8361;
                                                    {
                                                        userName
                                                            ?
                                                            addCommas(data && data.price)
                                                            :
                                                            "회원공개"
                                                    }
                                                </P>
                                            </FlexChild>
                                        )

                                }
                                <FlexChild justifyContent={"flex-end"} width={"46%"}>
                                    <VerticalFlex gap={20} justifyContent={"flex-end"}>
                                        <FlexChild justifyContent={"flex-end"} alignItems={"flex-end"}>
                                            <div onClick={addCartButtonClick} className={style.cartBtn} style={{ display: "flex", justifyContent: "flex-end" }}>
                                                {/* <CustomIcon name={"shoppingBag"} width={18} color={"#282828"} /> */}
                                                <P size={18} weight={500}>장바구니</P>
                                            </div>
                                        </FlexChild>
                                        <FlexChild justifyContent={"flex-end"} alignItems={"flex-end"}>
                                            <div onClick={deleteButtonClick} className={style.deleteBtn}>
                                                {/* <CustomIcon name={"shoppingBag"} width={18} color={"#282828"} /> */}
                                                <P size={18} weight={500}>삭제하기</P>
                                            </div>
                                        </FlexChild>
                                    </VerticalFlex>
                                </FlexChild>
                            </HorizontalFlex>
                        </FlexChild>
                    </HorizontalFlex >

            }
        </FlexChild>
    );
}

export default NewWishCard;